import {createContext, useContext} from "react";
import {useLocalStorage} from "../hooks/useLocalStorage";


export const AuthContext = createContext()

export const AuthProvider = ({children}) => {
    const [auth, setLocalStorageState] = useLocalStorage('auth', {})


    const contextValues = {
        setLocalStorageState,
        userId: auth.user_id,
        token: auth.token,
        isAuthenticated: !!auth.token
    };

    return (
        <AuthContext.Provider value={contextValues}>
            {children}
        </AuthContext.Provider>
    )
};

export const useAuthContext = () => {
    return useContext(AuthContext);
};